import React from "react";
import AppRouter from "./routers/AppRouter";
import { SnackbarProvider } from "notistack";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { Provider } from "react-redux";
import { store } from "./store/store";
import "./App.css";
import { reportError } from "./supabaseClient";
import ReactGA from "react-ga4";

ReactGA.initialize("G-MWN2YTM2HE");

const theme = createTheme({
    typography: {
        fontFamily: '"Helvetica Neue", Arial, sans-serif',
    },
    shape: {
        borderRadius: 2,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    boxShadow: "none",
                    fontWeight: 500,
                },
            },
            defaultProps: {
                disableElevation: true,
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                },
            },
        },
    },
});

class ErrorBoundary extends React.Component {
    state = { failed: false };

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error, info) {
        void reportError(
            "react-render",
            error,
            {
                componentStack: info.componentStack?.slice(0, 8000),
            },
            "fatal",
        );
    }

    render() {
        if (!this.state.failed) return this.props.children;

        return (
            <main style={{ padding: 24 }}>
                <h2>La aplicación ha sufrido un error</h2>
                <button onClick={() => window.location.reload()}>
                    Recargar
                </button>
            </main>
        );
    }
}

const App = () => {
    React.useEffect(() => {
        const handleError = (event) => {
            void reportError(
                "window-error",
                event.error || event.message,
                {
                    filename: event.filename,
                    line: event.lineno,
                    column: event.colno,
                },
                "fatal",
            );
        };

        const handleRejection = (event) => {
            void reportError("unhandled-promise", event.reason, {}, "fatal");
        };

        window.addEventListener("error", handleError);
        window.addEventListener("unhandledrejection", handleRejection);

        return () => {
            window.removeEventListener("error", handleError);
            window.removeEventListener("unhandledrejection", handleRejection);
        };
    }, []);

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider maxSnack={3}>
                    <ErrorBoundary>
                        <AppRouter />
                    </ErrorBoundary>
                </SnackbarProvider>
            </ThemeProvider>
        </Provider>
    );
};

export default App;
